import $http from "@/services/rest.service";

const BASE_PATH = "/pp/orgs";
export const registerProviderWSConnection = async (
  connectionId: string,
  orgId: string,
) => {
  return $http.post(`${BASE_PATH}/${orgId}/ws-connections`, { connectionId });
};
